import { useEffect, useState } from "react";
import { filterMapUnshippedInitState, getUnshippedFilterParams, setFilterParams } from "../store/unshippedOrdersSlice";
import { useTypedDispatch } from "./useTypedDispatch";
import { useTypedSelector } from "./useTypedSelector";

export default function useUnshippedOrders() {
  const filterMap = useTypedSelector(getUnshippedFilterParams());
  const dispatch = useTypedDispatch();

  const [filterApplied, setFilterApplied] = useState<boolean>();
  useEffect(() => {
    setFilterApplied(() => isFilterReseted());    
  }, [filterMap]);

  const setFilterCreatedDate = (from = '', till = '') => dispatch(setFilterParams({
    createdFrom: from,
    createdTill: till,
  }))

  const onFilterReset = () => dispatch(setFilterParams(filterMapUnshippedInitState));

  const isFilterReseted = (): boolean => !!Object.entries(filterMapUnshippedInitState)
    .find(([key, val]) => (filterMap as any)?.[key] !== val)


  return {
    filterMap,
    setFilterCreatedDate,
    filterApplied,
    onFilterReset,
  }
}